export default function takeBoundScalarTexture(model) {
    const texture = model.renderable.getScalarTexture?.();
    if (!model.scalarTextures) {
        model.scalarTextures = [];
    }
    if (texture && texture !== model.scalarTextures[0]) {
        model.scalarTextures[0] = texture;
        if (model.scalarTextureStrings) {
            model.scalarTextureStrings[0] = undefined;
        }
    }
}
